import { defineMessages } from 'react-intl';

export const jsmPortalPlaygroundMessages = defineMessages({
	sectionLabel: {
		id: 'JsmPortalPlayground.sectionLabel',
		defaultMessage: 'Jira Service Management preview',
	},
	serviceTeamTabListLabel: {
		id: 'JsmPortalPlayground.serviceTeamTabListLabel',
		defaultMessage: 'Service team',
	},
	teamItSupport: {
		id: 'JsmPortalPlayground.teamItSupport',
		defaultMessage: 'IT support',
	},
	teamItOperations: {
		id: 'JsmPortalPlayground.teamItOperations',
		defaultMessage: 'IT operations',
	},
	teamEngineering: {
		id: 'JsmPortalPlayground.teamEngineering',
		defaultMessage: 'Engineering',
	},
	teamHr: {
		id: 'JsmPortalPlayground.teamHr',
		defaultMessage: 'HR',
	},
	customCursorLabel: {
		id: 'JsmPortalPlayground.customCursorLabel',
		defaultMessage: 'You',
	},
	navigationPreviewLabel: {
		id: 'JsmPortalPlayground.navigationPreviewLabel',
		defaultMessage: 'Jira Service Management navigation preview for {teamName}',
	},
	productName: {
		id: 'JsmPortalPlayground.productName',
		defaultMessage: 'Jira Service Management',
	},
	back: {
		id: 'JsmPortalPlayground.back',
		defaultMessage: 'Back',
	},
	search: {
		id: 'JsmPortalPlayground.search',
		defaultMessage: 'Search',
	},
	create: {
		id: 'JsmPortalPlayground.create',
		defaultMessage: 'Create',
	},
	askRovo: {
		id: 'JsmPortalPlayground.askRovo',
		defaultMessage: 'Ask Rovo',
	},
	customizeHelpCenter: {
		id: 'JsmPortalPlayground.customizeHelpCenter',
		defaultMessage: 'Customize the help center',
	},
	incidentTitle: {
		id: 'JsmPortalPlayground.incidentTitle',
		defaultMessage: 'Service outage impacting Payment API',
	},
	addToWorkItem: {
		id: 'JsmPortalPlayground.addToWorkItem',
		defaultMessage: 'Add to work item',
	},
	description: {
		id: 'JsmPortalPlayground.description',
		defaultMessage: 'Description',
	},
	collapseDescription: {
		id: 'JsmPortalPlayground.collapseDescription',
		defaultMessage: 'Collapse description',
	},
	expandDescription: {
		id: 'JsmPortalPlayground.expandDescription',
		defaultMessage: 'Expand description',
	},
	incidentDescriptionStart: {
		id: 'JsmPortalPlayground.incidentDescriptionStart',
		defaultMessage: 'Customers are unable to complete transactions.',
	},
	incidentDescriptionEnd: {
		id: 'JsmPortalPlayground.incidentDescriptionEnd',
		defaultMessage: 'alerts have indicated <service>Payment API</service> disruptions.',
	},
	impactedService: {
		id: 'JsmPortalPlayground.impactedService',
		defaultMessage: 'Impacted service',
	},
	paymentApi: {
		id: 'JsmPortalPlayground.paymentApi',
		defaultMessage: 'Payment API',
	},
	onCall: {
		id: 'JsmPortalPlayground.onCall',
		defaultMessage: 'On call',
	},
	open: {
		id: 'JsmPortalPlayground.open',
		defaultMessage: 'Open',
	},
	investigating: {
		id: 'JsmPortalPlayground.investigating',
		defaultMessage: 'Investigating',
	},
	monitoring: {
		id: 'JsmPortalPlayground.monitoring',
		defaultMessage: 'Monitoring',
	},
	resolved: {
		id: 'JsmPortalPlayground.resolved',
		defaultMessage: 'Resolved',
	},
	runAutomation: {
		id: 'JsmPortalPlayground.runAutomation',
		defaultMessage: 'Run an automation rule',
	},
	details: {
		id: 'JsmPortalPlayground.details',
		defaultMessage: 'Details',
	},
	collapseDetails: {
		id: 'JsmPortalPlayground.collapseDetails',
		defaultMessage: 'Collapse details',
	},
	assignee: {
		id: 'JsmPortalPlayground.assignee',
		defaultMessage: 'Assignee',
	},
	responders: {
		id: 'JsmPortalPlayground.responders',
		defaultMessage: 'Responders',
	},
	requestType: {
		id: 'JsmPortalPlayground.requestType',
		defaultMessage: 'Request Type',
	},
	incident: {
		id: 'JsmPortalPlayground.incident',
		defaultMessage: 'Incident',
	},
	majorIncident: {
		id: 'JsmPortalPlayground.majorIncident',
		defaultMessage: 'Major incident',
	},
	collaborationChannels: {
		id: 'JsmPortalPlayground.collaborationChannels',
		defaultMessage: 'Collaboration channels',
	},
	rovoOpsTitle: {
		id: 'JsmPortalPlayground.rovoOpsTitle',
		defaultMessage: 'Accelerate incident resolution with Rovo Ops',
	},
	rovoOpsDescription: {
		id: 'JsmPortalPlayground.rovoOpsDescription',
		defaultMessage:
			'Leverage Rovo Ops to find similar incidents, identify root causes, and gather incident context.',
	},
	identifyRootCauses: {
		id: 'JsmPortalPlayground.identifyRootCauses',
		defaultMessage: 'Identify root causes',
	},
	findSimilarIncidents: {
		id: 'JsmPortalPlayground.findSimilarIncidents',
		defaultMessage: 'Find similar incidents',
	},
	likelyRootCauses: {
		id: 'JsmPortalPlayground.likelyRootCauses',
		defaultMessage: 'Likely root causes',
	},
	regenerateRootCauses: {
		id: 'JsmPortalPlayground.regenerateRootCauses',
		defaultMessage: 'Regenerate root causes',
	},
	collapseRovoOps: {
		id: 'JsmPortalPlayground.collapseRovoOps',
		defaultMessage: 'Collapse Rovo Ops',
	},
	expandRovoOps: {
		id: 'JsmPortalPlayground.expandRovoOps',
		defaultMessage: 'Expand Rovo Ops',
	},
	sources: {
		id: 'JsmPortalPlayground.sources',
		defaultMessage: 'Sources',
	},
	skipAnimation: {
		id: 'JsmPortalPlayground.skipAnimation',
		defaultMessage: 'Skip animation',
	},
});
